import { render, staticRenderFns } from "./EditPurchase.vue?vue&type=template&id=f9ba431c&scoped=true&"
var script = {}
import style0 from "./EditPurchase.vue?vue&type=style&index=0&id=f9ba431c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ba431c",
  null
  
)

export default component.exports